
const DEP = {

    init: function () {
        jQuery(document).on('ready', function () {
            console.log('Registering DEP...');
            DEP.triggerVisibility();

        });
    },

    triggerVisibility: function () {
        if ('IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype) {
            // continue!
        } else {
            jQuery('[data-inviewport="fade"]').addClass('opacity-100');
            jQuery('[data-inviewport="src"]').each(function (index, element) {
                jQuery(element).css('backgroundImage', 'url(' + jQuery(element).data('src') + ')');
            })
            return true;
        }

        const fadeInViewport = (entries, observer) => {
            jQuery.each(entries, function (i, o) {
                if (jQuery(o.target).data('inviewport') === 'fade') {
                    o.target.classList.toggle("opacity-100", o.isIntersecting);
                }
                if (o.isIntersecting && jQuery(o.target).data('inviewport') === 'src') {
                    jQuery(o.target).css('backgroundImage', 'url(' + jQuery(o.target).data('src') + ')');
                }
            })
        };

        const Obs = new IntersectionObserver(fadeInViewport);
        const obsOptions = {};

        // Attach observer to every [data-inviewport] element:
        const ELs_fadeInViewport = document.querySelectorAll('[data-inviewport]');
        jQuery.each(ELs_fadeInViewport, function (i, o) {
            Obs.observe(o, obsOptions);
        });
    }
};

module.exports = DEP;